import firebase from "firebase/app";
import "firebase/messaging";
import { setWebToken } from "sources/profile/user";

const AVAILABLE_NOTIFICATION_PERMISSIONS = ["default", "granted"];
const FIREBASE_AVAILABLE_ENVS = ["production", "test", "local", "development"];
const isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window.safari || window.safari.pushNotification);

export default class Firebase {
    constructor() {
        if (
            !FIREBASE_AVAILABLE_ENVS.includes(process.env.APP_ENV) ||
            typeof Notification === "undefined" ||
            !AVAILABLE_NOTIFICATION_PERMISSIONS.includes(Notification.permission)
        ) {
            return;
        }
        const initFCM = (permission) => {
            if (permission === "granted") {
                if (!firebase.apps.length) {
                    firebase.initializeApp(process.env.FIREBASE_CONFIG);
                }
                this.messaging = firebase.messaging();
                this.init();
            } else {
                console.error("Unable to get permission to notify.");
            }
        };
        if (!isSafari) {
            const requestPromise = Notification.requestPermission();
            requestPromise && requestPromise.then(initFCM);
        } else {
            const onEntryClick = () => {
                Notification.requestPermission().then(initFCM);
                document.getElementById("entry").removeEventListener("click", onEntryClick);
            };
            document.getElementById("entry").addEventListener("click", onEntryClick);
        }
    }

    registerServiceWorker = async () => {
        if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
            throw new Error("Service Worker is not supported in this browser.");
        }

        const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

        await navigator.serviceWorker.ready;

        return registration;
    };

    init = async () => {
        try {
            const serviceWorkerRegistration = await this.registerServiceWorker();

            const currentToken = await this.messaging.getToken({
                vapidKey: process.env.FIREBASE_VAPID,
                serviceWorkerRegistration,
            });

            if (currentToken) {
                this.sendTokenToServer(currentToken);
            }
        } catch (err) {
            console.error("An error occurred while retrieving token. ", err);
        }

        this.messaging.onMessage((payload) => {
            const { title, ...options } = payload.notification;
            // eslint-disable-next-line no-new
            if (title) {
                new Notification(title, options);
            }
        });
    };

    sendTokenToServer = (token) => {
        setWebToken({ token });
    };
}
